import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Swiper, { Navigation, Pagination } from 'swiper';
import styles from './index.css';
import { getThumbnail } from '@src/common/utils';
import { formatImage } from '@src/common/formatImage';

Swiper.use([Navigation, Pagination]);

const MainSwiper = (props) => {
    const { content } = props;

    const [currentData, setCurrentData] = useState({});

    useEffect(() => {
        new Swiper('#swiper1', {
            autoplay: true,
            loop: true,
            navigation: {
              prevEl: '#prev1',
              nextEl: '#next1'
            },
            pagination: {
                el: '#pagination1',
                renderBullet (index, className) {
                    return `<span class="${className}"></span>`;
                }
            },
            on: {
                slideChangeTransitionEnd () {
                    setCurrentData(content[this.realIndex]);
                }
            }
        });
    }, []);

    return (
        <div className={styles.swiperWp}>
            <div className={`${styles.swiper1} swiper`} id="swiper1">
                <div className="swiper-wrapper">
                    {
                        content.map((item, index) => {
                            return (
                                <div className="swiper-slide" key={index}>
                                    <a href={item.url} target="_blank" rel="noreferrer">
                                        <img className={styles.swiperImage} src={formatImage(getThumbnail(item), 690 * 2, 388 * 2)} alt={item.title} />
                                    </a>
                                </div>
                            );
                        })
                    }
                </div>
            </div>
            <div className={styles.prev1} id="prev1" />
            <div className={styles.next1} id="next1" />
            <div className={styles.swiperText}>
                <a href={currentData.url} target="_blank" rel="noreferrer">
                    {currentData.title}
                </a>
            </div>
            <div className={styles.pagination1} id="pagination1" />
        </div>
    );
};

MainSwiper.propTypes = {
    content: PropTypes.array
};

export default errorBoundary(MainSwiper);
